import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock'

export default () => {
  const triggers = document.querySelectorAll('.js-trigger-fillmat-popup');
  const popups = document.querySelectorAll('.js-fillmat-popup');
  if (triggers.length < 1) return;
  if (popups.length < 1) return;

  ;[...popups].forEach((popup) => {
    const close = popup.querySelector('.js-fillmat-close');
    const bgcontainer = popup.querySelector('.js-fillmat-popup-bg');
    const popupContent = popup.querySelector('.js-fillmat-popup-content');

    close.addEventListener('click', e => {
      enableBodyScroll(popupContent);
      popup.classList.remove('active');
    });
  
    bgcontainer.addEventListener('click', e => {
      if (popup.classList.contains('active')) {
        popup.classList.remove('active');
        enableBodyScroll(popupContent);
      }
    });
  })

  ;[...triggers].forEach((trigger) => {
    trigger.addEventListener('click', e => {
      const popup = document.getElementById(trigger.dataset.target);
      if (!popup) return;
      const popupContent = popup.querySelector('.js-fillmat-popup-content');
      const close = popup.querySelector('.js-fillmat-close');

      disableBodyScroll(popupContent);
      popup.classList.add('active');

      close.addEventListener('click', e => {
        enableBodyScroll(popupContent);
        popup.classList.remove('active');
      });
    });
  })
};


// WEBPACK FOOTER //
// ./src/js/modules/OpenPopup.js